// src/Login.tsx
import React, { useEffect, useState } from 'react';
import { login, logout } from '../types/authService';
import { useNavigate } from 'react-router-dom';
import { useUserLogin } from '../context/AuthContext';

const Login: React.FC = () => {
  const [userName, setUserName] = useState('');
  const [userRole, setUserRole] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState<boolean>(false);

  const navigate = useNavigate();
  const {setUserLogin } = useUserLogin();

  useEffect(() => {
   setUserLogin(null);
   logout();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(userName, password); // Assuming your login function expects both username and password
      setUserLogin({ name:  userName, role: userRole});
      
      navigate('/dashboard', { state: {userName, userRole}}); // Redirect to the dashboard on successful login
    } catch (err) {
      setError('Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="div-container">
      <p></p>
      <form onSubmit={handleSubmit}>
        <div>
          <input
            type="text"
            placeholder="UserName"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            required
          />
        </div>
        <div>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? 'Loading...' : 'Login'}
        </button>
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </form>
    </div>
  );
};

export default Login;
